export default __webpack_public_path__ + "static/media/wies-logo.3d7519ec.svg";